module.exports = __webpack_public_path__ + "static/media/facebook.87867528.svg";